/* easter-egg: random Julian/Juliette/Alonso/Ben buttons -> modal */

export function initEasterEgg() {
  const JULIAN_IMAGE = "/julian.png";
  const JULIETTE_IMAGE = "/juliette.png";
  const ALONSO_VIDEO = "/alonso.mov";
  const BEN_IMAGE = "/ben.png";
  const MAX_BUTTONS = 4;           // concurrent buttons
  const SHOW_DURATION = 6000;      // ms visible before auto-hide
  const SPAWN_INTERVAL = 4000;     // ms between spawn attempts
  const BUTTON_CLASS = "jj-eebtn";

  /* inject styles */
  const style = document.createElement("style");
  style.textContent = `
    .jj-eebtn {
      position: fixed;
      z-index: 99999;
      padding: 6px 10px;
      font-size: 12px;
      border-radius: 6px;
      background: rgba(255,255,255,0.95);
      box-shadow: 0 6px 18px rgba(0,0,0,0.12);
      cursor: pointer;
      transition: transform .18s ease, opacity .3s ease;
      opacity: 0;
      transform: scale(.85);
      pointer-events: auto;
    }
    .jj-eebtn.show { opacity: 1; transform: scale(1); }
    .jj-modal-backdrop {
      position: fixed; inset: 0; display:flex; align-items:center; justify-content:center;
      background: rgba(0,0,0,0.55); z-index: 100000; padding: 20px;
    }
    .jj-modal {
      background: white; border-radius: 10px; max-width: 420px; width: 100%;
      box-shadow: 0 20px 60px rgba(0,0,0,0.25); padding: 18px; text-align:center;
    }
    .jj-modal img, .jj-modal video { max-width: 100%; border-radius: 8px; display:block; margin: 0 auto 10px;}
    .jj-caption { font-weight:600; font-size:14px; }
    .jj-close { margin-top:8px; font-size:13px; color:#666; cursor:pointer; }
  `;
  document.head.appendChild(style);

  /* modal builder */
  function showModal(mediaUrl: string, name: string, isVideo = false) {
    const backdrop = document.createElement("div");
    backdrop.className = "jj-modal-backdrop";
    const mediaElement = isVideo
      ? `<video src="${mediaUrl}" controls autoplay loop alt="${name}'s video"></video>`
      : `<img src="${mediaUrl}" alt="${name}'s face"/>`;
    backdrop.innerHTML = `
      <div class="jj-modal" role="dialog" aria-modal="true">
        ${mediaElement}
        <div class="jj-caption">${name} — big eyebrows, major vibe.</div>
        <div class="jj-close">Close</div>
      </div>
    `;
    (backdrop.querySelector(".jj-close") as HTMLElement).onclick = () => backdrop.remove();
    backdrop.onclick = (e) => { if (e.target === backdrop) backdrop.remove(); };
    document.body.appendChild(backdrop);
  }

  /* spawn a button at random position */
  function spawnButton() {
    if (document.querySelectorAll(`.${BUTTON_CLASS}`).length >= MAX_BUTTONS) return;

    // Randomly choose Julian, Juliette, Alonso or Ben
    const rand = Math.random();
    let name: string, media: string, isVideo: boolean;
    if (rand < 0.25) {
      name = "Julian";
      media = JULIAN_IMAGE;
      isVideo = false;
    } else if (rand < 0.5) {
      name = "Juliette";
      media = JULIETTE_IMAGE;
      isVideo = false;
    } else if (rand < 0.75) {
      name = "Alonso";
      media = ALONSO_VIDEO;
      isVideo = true;
    } else {
      name = "Ben";
      media = BEN_IMAGE;
      isVideo = false;
    }

    const btn = document.createElement("button");
    btn.className = BUTTON_CLASS;
    btn.textContent = `Click here for ${name}`;

    // Random safe margins away from edges
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const left = Math.floor(Math.random() * (vw - 120));
    const top  = Math.floor(Math.random() * (vh - 40));
    btn.style.left = `${left}px`;
    btn.style.top  = `${top}px`;
    btn.onclick = (e) => {
      e.stopPropagation();
      showModal(media, name, isVideo);
      // optional: remove immediately after click
      btn.remove();
    };
    document.body.appendChild(btn);
    // animate in
    requestAnimationFrame(() => btn.classList.add("show"));
    // auto-hide later if untouched
    const hideTimer = setTimeout(() => {
      btn.classList.remove("show");
      setTimeout(()=> btn.remove(), 350);
    }, SHOW_DURATION);

    // if user hovers keep it, if clicked it's removed anyway
    btn.addEventListener("mouseenter", () => clearTimeout(hideTimer));
  }

  // periodically attempt to spawn
  const spawner = setInterval(spawnButton, SPAWN_INTERVAL);

  // optional keyboard shortcut to toggle off (Escape)
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.querySelectorAll(`.${BUTTON_CLASS}`).forEach(n=>n.remove());
      document.querySelectorAll(".jj-modal-backdrop").forEach(n=>n.remove());
      clearInterval(spawner);
    }
  });

  // expose for debugging
  (window as any).__julianEgg = { spawnButton, showModal, stop: () => clearInterval(spawner) };
}
